import React      from 'react';
import CSSModules from 'react-css-modules';
import {Pie} from 'react-chartjs-2';

import { connect } from 'react-redux';

import style from './style.scss';
import * as statsList from "../../actions/statsList";

class StatsList extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            chartData: {},
            chartOptions: {}
        }
    }

    componentDidMount() {
        this.props.getReferralStats();
    }

    componentWillReceiveProps(nextProps) {
        this._getChartData(nextProps.referralStats);
    }

    _getChartData(stats) {

        let values = [];
        let labels = [];
        let colors = [
            'dodgerblue',
            'orchid',
            'peachpuff',
            'indianred',
            'seagreen',
            'sienna',
            'teal',
            'crimson'
        ];

        let counts = {};
        if(stats.length > 0) {
            stats.forEach(function (x) {
                counts[x] = (counts[x] || 0) + 1;
            });

        }

        {Object.keys(counts).map( function(stat) {
            let label;
            switch(stat) {
                case "word_of_mouth":
                    label = "Word of Mouth";
                    break;
                case "invite":
                    label = "Email Invitation";
                    break;
                case "magazine":
                    label = "Magazine";
                    break;
                case "search":
                    label = "Search Engine";
                    break;
                case "other":
                    label = "Other";
                    break;
                case "cant_remember":
                    label = "Can't Remember";
                    break;
                default:
                    label = "Not Specified";
                    break;
            }

            labels.push(
                label
            );

            return (
                values.push(
                    counts[stat]
                )
            )
        })}

        let options = {
            responsive: true,
            maintainAspectRatio: true,
            legend: {
                display: true,
                position: 'bottom',
                labels: {
                    fontColor: 'black'
                }
            }
        };

        let data = {
            datasets: [{
                data: values,
                backgroundColor: colors
            }],
            labels: labels
        };

        this.setState({ chartData: data });
        this.setState({ chartOptions: options });
    }

    _getChartContainer(width = 300, height = 300) {
        return (
            <Pie data={this.state.chartData} options={this.state.chartOptions} width={width} height={height} />
        )
    }

    render() {

        return (

            <article>

                <section styleName="stats">

                    <article>
                        {Object.keys(this.state.chartData).length > 0 && Object.keys(this.state.chartOptions).length > 0 &&
                        <div styleName="chart--container">
                            <h1 styleName="chart--header">Referrers</h1>
                                {this._getChartContainer()}
                        </div>
                        }
                    </article>

                </section>

            </article>
        );
    }
}

function mapStateToProps(state) {

    return state.statsList;
}

function mapDispatchToProps(dispatch) {

    return {
        getReferralStats: () => {
            dispatch(statsList.getReferralStats());
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CSSModules(StatsList, style));


// WEBPACK FOOTER //
// ./components/StatsList/index.js